import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./app.component').then((a) => a.AppComponent),
    loadChildren: () =>
      import('@embrace-it/master-locations-library').then(
        (ml) => ml.masterLocationsLibraryMasterLocationsLibraryRoutes
      ),
  },
];
